import { useTranslation } from 'react-i18next';
import { Card } from '../ui/Card';
import type { RentalPlan } from '../../types/api.js';

interface RentalPlanTableProps {
  /** レンタルプランリスト */
  plans: RentalPlan[];
}

/**
 * @graph-stack mall
 * @graph-domain Operations
 * @graph-business レンタルプラン比較テーブル。3プランをglassテーブルで表示し推奨プランをハイライト
 * @graph-connects none
 */
export function RentalPlanTable({ plans }: RentalPlanTableProps) {
  const { t } = useTranslation();

  return (
    <Card variant="glass">
      <h3 className="text-sm font-semibold text-[var(--color-text-primary)] mb-3">
        {t('scoring.rentalPlanTitle')}
      </h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-[var(--color-text-muted)] text-xs">
              <th className="text-left py-2 pr-4">{t('scoring.planLabel')}</th>
              <th className="text-right py-2 px-4">{t('scoring.planRental')}</th>
              <th className="text-right py-2 px-4">{t('scoring.planBep')}</th>
              <th className="text-right py-2 pl-4">{t('scoring.planA1')}</th>
            </tr>
          </thead>
          <tbody>
            {plans.map((plan, i) => (
              <tr
                key={i}
                className={`
                  border-t border-[var(--color-border)]
                  ${plan.highlight ? 'bg-[var(--color-accent-muted)] font-semibold' : ''}
                `}
              >
                <td className="py-2.5 pr-4 text-[var(--color-text-primary)]">
                  {plan.highlight && (
                    <span className="inline-block w-2 h-2 rounded-full bg-[var(--color-accent-primary)] mr-2" />
                  )}
                  {plan.label}
                </td>
                <td className="text-right py-2.5 px-4 font-mono text-[var(--color-text-primary)]">
                  {plan.rental.toLocaleString()}
                </td>
                <td className="text-right py-2.5 px-4 font-mono text-[var(--color-text-secondary)]">
                  {plan.bep.toFixed(1)}
                  {t('scoring.months')}
                </td>
                <td className="text-right py-2.5 pl-4 font-mono text-[var(--color-text-secondary)]">
                  {plan.a1}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
